(function () {
  if (window.__IdleLoaderInitialized) return;
  window.__IdleLoaderInitialized = true;

  function init() {
    var doc = document;
    if (!doc) return;
    var body = doc.body;
    var pageType = (body && body.getAttribute('data-page-type')) || 'all';
    var loaded = Object.create(null);
    var idleQueue = [];
    var interactionQueue = [];
    var cartIntentQueue = [];
    var idleScheduled = false;
    var interactionBound = false;
    var cartIntentBound = false;
    var sharedObserver = null;

    function parsePages(el) {
      var raw = el.getAttribute('data-pages');
      if (!raw) return ['all'];
      return raw.split(',').map(function (entry) {
        return entry.trim();
      }).filter(Boolean);
    }

    function shouldRun(el) {
      var pages = parsePages(el);
      if (!pages.length) return true;
      if (pages.indexOf('all') > -1) return true;
      return pageType && pages.indexOf(pageType) > -1;
    }

    function applyAttributes(source, target) {
      var type = source.getAttribute('data-type');
      if (type) target.type = type;
      if (source.getAttribute('data-async') === 'true') target.async = true;
      if (source.getAttribute('data-defer') === 'false') {
        target.defer = false;
      }
      if (source.getAttribute('data-nomodule') === 'true') target.noModule = true;
      var crossorigin = source.getAttribute('data-crossorigin');
      if (crossorigin) target.crossOrigin = crossorigin;
      var integrity = source.getAttribute('data-integrity');
      if (integrity) target.integrity = integrity;
      var referrerPolicy = source.getAttribute('data-referrerpolicy');
      if (referrerPolicy) target.referrerPolicy = referrerPolicy;
      var nonce = source.nonce || source.getAttribute('nonce');
      if (nonce) target.nonce = nonce;
    }

    function injectScript(sourceEl, url) {
      if (!url) return;
      if (loaded[url]) return;
      loaded[url] = true;
      var script = doc.createElement('script');
      applyAttributes(sourceEl, script);
      script.src = url;
      if (!script.async && script.type !== 'module' && script.defer !== false) {
        script.defer = true;
      }
      (body || doc.head || doc.documentElement).appendChild(script);
    }

    function finalizePlaceholder(el) {
      if (!el) return;
      el.dataset.deferLoaded = 'true';
      if (el.tagName === 'SCRIPT' && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }

    function loadPlaceholder(el) {
      if (!el || el.dataset.deferLoaded === 'true') return;
      if (!shouldRun(el)) return;
      var src = el.getAttribute('data-defer-src');
      if (!src) return;
      injectScript(el, src);
      finalizePlaceholder(el);
    }

    function loadSentinel(el) {
      if (!el || el.dataset.deferLoaded === 'true') return;
      if (!shouldRun(el)) return;
      var urls = el.getAttribute('data-defer-visible');
      if (!urls) return;
      urls.split(',').map(function (url) {
        return url.trim();
      }).filter(Boolean).forEach(function (url) {
        injectScript(el, url);
      });
      finalizePlaceholder(el);
    }

    function scheduleIdle() {
      if (idleScheduled || !idleQueue.length) return;
      idleScheduled = true;
      var run = function () {
        idleScheduled = false;
        var queue = idleQueue.slice();
        idleQueue.length = 0;
        queue.forEach(loadPlaceholder);
      };
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(function () {
          run();
        }, { timeout: 2500 });
      } else {
        setTimeout(run, 1500);
      }
    }

    function flushInteractionQueue() {
      if (!interactionQueue.length) return;
      var queue = interactionQueue.slice();
      interactionQueue.length = 0;
      queue.forEach(loadPlaceholder);
    }

    function ensureInteractionListeners() {
      if (interactionBound) return;
      interactionBound = true;
      var events = ['scroll', 'mousemove', 'touchstart', 'pointerdown', 'keydown'];
      var passiveOptions = { passive: true, once: true };
      var handler = function () {
        flushInteractionQueue();
      };
      events.forEach(function (eventName) {
        var options = eventName === 'keydown' ? { once: true } : passiveOptions;
        window.addEventListener(eventName, handler, options);
      });
    }

    function flushCartIntentQueue() {
      if (!cartIntentQueue.length) return;
      var queue = cartIntentQueue.slice();
      cartIntentQueue.length = 0;
      queue.forEach(loadPlaceholder);
    }

    function isCartIntentTarget(target) {
      if (!target || !target.closest) return false;
      return !!target.closest(
        '[aria-controls="mini-cart"],' +
        '[href*="/cart"],' +
        '[action*="/cart"],' +
        '[name="checkout"],' +
        '[name="add"],' +
        '[data-action="open-drawer"][aria-controls*="cart"],' +
        '[data-action="add-to-cart"],' +
        'cart-count,' +
        'cart-drawer,' +
        'cart-notification'
      );
    }

    function ensureCartIntentListeners() {
      if (cartIntentBound) return;
      cartIntentBound = true;

      var trigger = function () {
        flushCartIntentQueue();
      };

      var pointerHandler = function (event) {
        if (!isCartIntentTarget(event.target)) return;
        trigger();
      };

      var keyboardHandler = function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (!isCartIntentTarget(event.target)) return;
        trigger();
      };

      document.addEventListener('pointerdown', pointerHandler, { passive: true });
      document.addEventListener('click', pointerHandler, { passive: true });
      document.addEventListener('focusin', pointerHandler, { passive: true });
      document.addEventListener('keydown', keyboardHandler);

      ['variant:added', 'cart:open'].forEach(function (eventName) {
        document.addEventListener(eventName, trigger, { passive: true, once: true });
        window.addEventListener(eventName, trigger, { passive: true, once: true });
      });
    }

    function observeElement(el, callback) {
      if (!('IntersectionObserver' in window)) {
        callback(el);
        return;
      }
      if (!sharedObserver) {
        sharedObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && entry.intersectionRatio <= 0) return;
            var target = entry.target;
            sharedObserver.unobserve(target);
            var cb = target.__idleLoaderCallback;
            if (typeof cb === 'function') {
              delete target.__idleLoaderCallback;
              cb(target);
            }
          });
        }, { rootMargin: '600px 0px' });
      }
      el.__idleLoaderCallback = callback;
      sharedObserver.observe(el);
    }

    function registerScript(el) {
      if (!el || el.dataset.deferRegistered === 'true') return;
      el.dataset.deferRegistered = 'true';
      if (!shouldRun(el)) return;
      var when = (el.getAttribute('data-when') || 'idle').toLowerCase();
      if (when === 'interaction') {
        interactionQueue.push(el);
        ensureInteractionListeners();
      } else if (when === 'cart-intent') {
        cartIntentQueue.push(el);
        ensureCartIntentListeners();
      } else if (when === 'visible') {
        observeElement(el, loadPlaceholder);
      } else if (when === 'immediate') {
        loadPlaceholder(el);
      } else {
        idleQueue.push(el);
        scheduleIdle();
      }
    }

    function registerSentinel(el) {
      if (!el || el.dataset.deferRegistered === 'true') return;
      el.dataset.deferRegistered = 'true';
      if (!shouldRun(el)) return;
      observeElement(el, loadSentinel);
    }

    function scan(root) {
      if (!root) return;
      if (root.nodeType === 1) {
        if (root.matches('script[data-defer-src]')) {
          registerScript(root);
        }
        if (root.hasAttribute && root.hasAttribute('data-defer-visible')) {
          registerSentinel(root);
        }
      }
      var scripts = root.querySelectorAll ? root.querySelectorAll('script[data-defer-src]') : [];
      for (var i = 0; i < scripts.length; i += 1) {
        registerScript(scripts[i]);
      }
      var sentinels = root.querySelectorAll ? root.querySelectorAll('[data-defer-visible]') : [];
      for (var j = 0; j < sentinels.length; j += 1) {
        registerSentinel(sentinels[j]);
      }
    }

    scan(doc);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i += 1) {
          var node = mutation.addedNodes[i];
          if (!node || node.nodeType !== 1) continue;
          scan(node);
        }
      });
    }).observe(doc.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
